import { takeLatest } from "redux-saga/effects";

import { defaultReturn, makePayload, generateDefaultActions, subKeySaga } from "../utils/helpers";

export const GET_FUND_METRICS_UTL = generateDefaultActions("GET_FUND_METRICS_UTL");
export const getFundMetrics = payload => makePayload(GET_FUND_METRICS_UTL.value, payload);
function* getFundMetricsSaga(payload) {
  const url = `/metrics/funds/${payload.fundId}`;
  const requestSaga = subKeySaga(payload.subKey);
  yield requestSaga(GET_FUND_METRICS_UTL, url, "POST", { isBroker: payload.hasBrokerAccess });
}

const initialState = {
  metricData: []
};

export function newFundReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FUND_METRICS_UTL.success:
      return defaultReturn(state, payload.data, "metricData");

    default:
      return state;
  }
}

export function* newFundSaga() {
  yield takeLatest(GET_FUND_METRICS_UTL.value, getFundMetricsSaga);
}
